const defaultList = {
  id: null,
  source: null,
  rating: null,
  width: null,
  height: null,
  tags: null,
  character: null,
  mimetype: null,
  file_size: null,
  pixiv_id: null,
  artist: null,
  file_url: null,
  sample: null,
  preview: null,
  checked: false,
  caption: null,
};

export default defaultList;
